<div class="d-flex align-items-end">
  <button class="btn tab-pagination" *ngIf="showArrowButton()" (click)="moveLeft()" [attr.aria-label]="'moveLeft' | translate">
    <fa-icon class="arrow-icon" [icon]="arrowIconLeft"></fa-icon>
  </button>
  <drag-scroll scrollbar-hidden drag-scroll-y-disabled [snap-offset]="20"
               class="nav nav-tabs tab-header" ngbNav #nav="ngbNav" [(activeId)]="activeId"
               (navChange)="onTabChange($event)">
    <ng-container [ngbNavItem]="idx" *ngFor="let materialTab of materialTabs; let idx=index; trackBy: trackById">
      <a ngbNavLink class="tab-label" drag-scroll-item [attr.aria-label]="(materialTab.translationKey ? (materialTab.translationKey | translate) : materialTab.name) + ' ' + fgTitle">
        <!-- Mobile-only label content with extra padding -->
        <div class="d-flex d-md-none flex-column align-items-center tab-label-content py-3 px-4" data-automation-id="rollups-tab"
             [class.checked-out]="!availableStatuses.includes(availabilityUpdates && availabilityUpdates[idx]?.status?.general)"
             [class.alwaysAvailable]="formatByCode?.alwaysAvailable"
             [class.notLoggedIn]="availabilityUpdates && availabilityUpdates[idx]?.status?.general === 'NotLoggedIn'">
          <ng-container *ngIf="materialTab?.name; else emptyLabelMobile">
            <div class="label mb-2" data-automation-id="rollups-tab-title">
              {{ materialTab.translationKey ? (materialTab.translationKey | translate) : materialTab.name }}
            </div>
          </ng-container>
          <ng-template #emptyLabelMobile>
            <div class="label mb-2" data-automation-id="rollups-tab-title" translate>other</div>
          </ng-template>
        </div>

        <!-- Desktop-only label content without extra padding -->
        <div class="d-none d-md-flex flex-column align-items-center tab-label-content" data-automation-id="rollups-tab"
             [class.checked-out]="!availableStatuses.includes(availabilityUpdates && availabilityUpdates[idx]?.status?.general)"
             [class.alwaysAvailable]="formatByCode?.alwaysAvailable"
             [class.notLoggedIn]="availabilityUpdates && availabilityUpdates[idx]?.status?.general === 'NotLoggedIn'">
          <ng-container *ngIf="materialTab?.name; else emptyLabelDesktop">
            <div class="label" data-automation-id="rollups-tab-title">
              {{ materialTab.translationKey ? (materialTab.translationKey | translate) : materialTab.name }}
            </div>
          </ng-container>
          <ng-template #emptyLabelDesktop>
            <div class="label" data-automation-id="rollups-tab-title" translate>other</div>
          </ng-template>
        </div>
      </a>
      <ng-template ngbNavContent>
        <app-rollup-tabs-content-rapido
          [materialTab]="materialTab"
          [hasEcontentIssues]="hasEcontentIssues[idx]"
          [availabilityUpdateInfo]="availabilityUpdates && availabilityUpdates[idx]"
          [queryParams]="queryParams"
          [fgId]="fgId"
          [fgTitle]="fgTitle"
          [ariaDescribedBy]="ariaDescribedBy"
          (getIt$)="getIt$.emit($event)"
          (placeHold$)="placeHold$.emit($event)"
          (checkLocationAndEditionInfo$)="checkLocationAndEditionInformation(idx)"
          [language]="language"
          [author]="author"
          [publicationYear]="publicationYear"
          [isbn]="isbn"
          [publisher]="publisher"
          [specificEdition]="specificEdition"
          >
        </app-rollup-tabs-content-rapido>
      </ng-template>
    </ng-container>
  </drag-scroll>
  <button class="btn tab-pagination" *ngIf="showArrowButton()" (click)="moveRight()" [attr.aria-label]="'moveRight' | translate">
    <fa-icon class="arrow-icon" [icon]="arrowIconRight"></fa-icon>
  </button>
</div>
<div [ngbNavOutlet]="nav"></div>
